import { useLocation } from 'react-router-dom'
import { useAppSelector, useAppDispatch } from 'app/state'
import { useEffect } from 'react'

import { RequestStatus } from 'features/common'
import { accountRequest } from '../../state/accountSlice'
import { isPublicMapUrl } from 'features/builder/paths'

function useGetAccountData() {
  const dispatch = useAppDispatch()
  const accountData = useAppSelector((state) => state.account?.data)
  const accountDataStatus = useAppSelector((state) => state.account?.dataStatus)
  const user = useAppSelector((state) => state.users.me)
  const location = useLocation()
  const isPublicMapView = isPublicMapUrl(location.pathname)

  useEffect(() => {
    if (!isPublicMapView && user && accountDataStatus === RequestStatus.Idle) dispatch(accountRequest())
  }, [dispatch, isPublicMapView, user, accountDataStatus])

  return accountData
}

export default useGetAccountData
